<template>
  <div style="width:100%;margin:0 auto;padding:0;padding: 0">
    <div class="hello yuyuyu">
      <el-container>
          <Content></Content>
      </el-container>
      <!-- <div style="width:100%;margin:0;padding: 0;overflow:hidden;">
        <AreaItem ></AreaItem>
      </div> -->
    </div>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Content from './view/Content.vue'
  // import AreaItem from './common/AreaItem.vue'
  // import Content from './common/Content.vue'
  // import { mapActions } from "vuex"
  export default {
    name: 'HoneIdex',
    components:{
      Header,Content
    },
    props: {
      msg: String
    },
    created () {
      // this.getAccountInfo()
    }, 
    mounted () {
      
    },
    methods: {
      // ...mapActions(['getAccountInfo'])
    }
  }
</script>
<style scoped>
  .el-header, .el-footer {
    color: #333;
    text-align: center;
    /* line-height: 60px; */
    background: #08172e!important;
    margin-bottom: 10px;
  }
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
  }
  .el-main {
    background-color: #08172e;
    color: #333;
    text-align: center;
  }
  body > .el-container {
    margin:0;
    padding: 0;
    /*margin-bottom: 40px;*/
  }
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  li.el-menu-item{
    padding: 0 77px;
  }
  .el-menu.el-menu--horizontal{
    border-bottom: none;
  }
  .el-header[data-v-8dc7cce2], .el-footer[data-v-8dc7cce2]{
    line-height: unset;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index/home.vue